import React from "react";
import styles from "./FullScreenLoader.module.scss";

export const FullScreenLoader: React.FC<{ transparent?: boolean }> = ({
  transparent = false,
}) => {
  return (
    <div
      className={`${styles.loaderOverlay} ${
        transparent ? styles.transparentOverlay : ""
      }`}
      role="status"
      aria-live="polite"
    >
      <div className={styles.loader} />
    </div>
  );
};
